import i from './new-document.container';

export default i;
